import { NavLink } from "react-router-dom";
import { useState } from "react";
import { PencilSquareIcon } from "@heroicons/react/24/solid";

import SectionLabel from "../../../app/universalComponents/SectionLabel";
import StatusIndicator from "../../../app/universalComponents/StatusIndicator";
import Placeholder from "../../../assets/images/placeholderPoster.png";
import EventActions from "./EventActions";
import EventInfoForm from "../../create-edit/EventInfoForm";

import { formatStatus } from "../../../app/utils/formatting";

export default function ActiveEventHeader({ activeEvent }) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <>
      <header className="shrink-0 border-b px-4 pt-6">
        <div className="mx-auto w-full max-w-[1280px]">
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="relative flex min-w-0 gap-4">
              <img
                src={activeEvent.poster || Placeholder}
                alt={`${activeEvent.title} poster`}
                className="h-28 rounded-sm object-cover shadow-sm border"
              />

              <article className="min-w-0">
                <SectionLabel>Event Dashboard</SectionLabel>

                <h1 className="flex min-w-0 items-center gap-2 text-3xl md:text-4xl font-semibold">
                  <span className="truncate">
                    {activeEvent.title}
                  </span>
                </h1>

                <p className="truncate text-sm">
                  {activeEvent.display_date} | {activeEvent.venue}
                </p>

                <StatusIndicator tone={activeEvent.status}>
                  {formatStatus(activeEvent.status)}
                </StatusIndicator>
              </article>
              {!["cancelled", "past"].includes(activeEvent.status) && (
              <button type="button" onClick={() => setIsEditModalOpen(true)} className="absolute -right-1 -top-4 text-3xl transition-transform hover:scale-105 md:static md:px-2 md:text-4xl">
                <PencilSquareIcon className="size-10" aria-hidden="true" />
              </button>)}
            </div>

            <EventActions id={activeEvent.id} status={activeEvent.status} slug={activeEvent.slug}></EventActions>

          </div>

          <nav className="mt-4 flex justify-center gap-8 md:justify-start">
            <NavLink
              to="overview"
              className={({ isActive }) => `border-b-2 px-1 pb-1 text-sm font-medium transition ${isActive ? "border-black text-black" : "border-transparent text-gray-500 hover:text-black"}`}
            >
              Overview
            </NavLink>

            <NavLink
              to="orders"
              className={({ isActive }) => `border-b-2 px-1 pb-1 text-sm font-medium transition ${isActive ? "border-black text-black" : "border-transparent text-gray-500 hover:text-black"}`}
            >
              Orders
            </NavLink>

            <NavLink
              to="tickets"
              className={({ isActive }) => `border-b-2 px-1 pb-1 text-sm font-medium transition ${isActive ? "border-black text-black" : "border-transparent text-gray-500 hover:text-black"}`}
            >
              Tickets
            </NavLink>
          </nav>
        </div>
      </header>
      {isEditModalOpen && (
        <EventInfoForm
          activeEvent={activeEvent}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}
    </>
  );
}